export default __webpack_public_path__ + "static/media/aam-logo.8ca0feb7.png";